import React from 'react';
import { INotificationProps } from '../../types/notification';
import CircleCheckIcon from '../icons/CircleCheckIcon';
import DangerIcon from '../icons/DangerIcon';
import XIcon from '../icons/XIcon';
import Typography from '../typography/Typography';
import './notification.scss';

const Notification: React.FC<INotificationProps> = ({
  variant,
  message,
  fullWidth,
  button,
  onClose,
  className = '',
  additionalText = '',
  isSnackBar = false,
  custom = false,
  customTitle = null,
  children = null,
  icon,
}) => {
  const classBase = 'notification';

  const getColor = () => {
    if (variant === 'error') return 'red5';
    if (variant === 'success') return 'atlantis5';
    if (variant === 'neutral') return 'blue5';
    return 'asphalt7';
  };

  const getBgColor = () => {
    if (variant === 'error') return 'red1';
    if (variant === 'success') return 'atlantis1';
    if (variant === 'neutral') return 'blue1';
    return 'asphalt2';
  };

  const color = getColor();
  const bgColor = getBgColor();

  const renderIcon = () => {
    switch (variant) {
      case 'success':
        return (
          <CircleCheckIcon
            color={color}
            className="notification-icon"
          />
        );
      case 'info': case 'neutral': case 'error':
        return (
          <DangerIcon
            color={color}
            width={20}
            className="notification-icon"
          />
        );
      default:
        return null;
    }
  };

  return (
    <div
      className={`
        ${classBase} 
        ${className} 
        ${classBase}-variant-${variant} 
        bg-color-${bgColor}
        ${fullWidth ? 'w-12' : ''}
        ${customTitle ? 'column' : ''}
        d-flex
        align-center
        ${isSnackBar ? 'snackbar' : ''}
      `}
      data-testid={`notification-${variant}`}
    >
      {customTitle
        ? <div className="custom-title">{customTitle}</div>
        : ''}
      <span className="left-icon-wrapper">
        {icon || renderIcon()}
      </span>

      <div className="d-flex flex-direction-column">

        <div className="d-flex  justify-content-space-between ">
          {custom
            ? (
              // eslint-disable-next-line
              <>{children}</>
            )
            : (
              <Typography
                color={variant === 'info' || additionalText ? 'dark' : color}
                variant={variant === 'neutral' || additionalText ? 'subtitle1' : 'body1'}
                className="d-flex align-center"
                data-testid={`notification-${variant}_title`}
              >
                {message}
              </Typography>
            )}
          {onClose && (
            <span className="right-icon-wrapper">
              <XIcon width={15} color="asphalt7" onClick={onClose} />
            </span>
          )}
        </div>

        {additionalText && (
        <Typography
          color="dark"
          variant="body1"
          className="d-flex align-center m-t-18 text-justify"
        >
          {additionalText}
        </Typography>
        )}

        {button && <div className="m-t-14 m-b-4">{button}</div>}
      </div>

    </div>
  );
};

export default Notification;
